import AvailabilityNotice from '../../components/AvailabilityNotice/AvailabilityNotice';
import useListingAvailability from '../../util/useListingAvailability';
import { getListingAvailability } from '../../util/listingAvailability.shared';
import React, { useState, useEffect } from 'react';
import { getAdvertiserProfile } from '../../util/advertiserProfile';
import { getOfferType, isSale, offerLabel, priceUnit, fieldsForOffer } from '../../util/offerType';
import { getCommitmentPrices, lowestCommitmentPrice } from '../../util/commitmentPricing';
import { listingPageMetadata } from '../../util/marketplaceSeo';
import { getListingLocationKey, getListingLocationName } from '../../util/listingLocationGroups';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { startListingVisit, trackListingClick } from '../../util/listingAnalytics';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
  NO_ACCESS_PAGE_USER_PENDING_APPROVAL,
  NO_ACCESS_PAGE_VIEW_LISTINGS,
} from '../../util/urlHelpers';
import {
  isErrorNoViewingPermission,
  isErrorUserPendingApproval,
  isForbiddenError,
} from '../../util/errors.js';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers.js';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { formatMoney } from '../../util/currency';

import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import { toggleFavorite, selectIsFavorite } from '../../ducks/favorites.duck';

import {
  Page,
  NamedLink,
  NamedRedirect,
  ResponsiveImage,
  AvatarLarge,
  IconSpinner,
  Map,
  Modal,
} from '../../components';
import InquiryForm from './InquiryForm/InquiryForm';
import VisitRequestPanel, { visitModalContainerClassName } from './VisitRequest/VisitRequestPanel';
import IconVisitCalendar from './VisitRequest/IconVisitCalendar';
import LocationOfficeSelector, {
  officeTitle,
  officePublicData,
  locationListingsReturn,
} from './LocationOfficeSelector';
import { normalizeVisitAvailability, visitTimeZone } from '../../util/visitRequest';
import { createResourceLocatorString } from '../../util/routes';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

import {
  sendInquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
  fetchSimilarListings,
  similarListingsKey,
  fetchLocationListings,
  locationListingsKey,
} from './ListingPage.duck';

import { LoadingPage, ErrorPage, priceData, listingImages } from './ListingPage.shared';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
  isFieldForListingType,
} from '../../util/fieldHelpers.js';
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';

import css from './ListingPageMarketplace.module.css';

const { UUID } = sdkTypes;

/* ============================================
   ICÔNES SVG
============================================ */

const IconLocation = () => (
  <svg className={css.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

const IconUsers = () => (
  <svg className={css.highlightIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

const IconArea = () => (
  <svg className={css.highlightIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
    />
  </svg>
);

const IconClock = () => (
  <svg className={css.highlightIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const IconWifi = () => (
  <svg className={css.highlightIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
    />
  </svg>
);

const IconHeart = ({ filled }) => (
  <svg
    className={css.heartIcon}
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    />
  </svg>
);

const IconShare = () => (
  <svg className={css.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
    />
  </svg>
);

const IconCheck = () => (
  <svg className={css.checkIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
    />
  </svg>
);

const IconMessage = () => (
  <svg className={css.ctaIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>
);

const IconCalendar = () => (
  <svg className={css.ctaIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

const IconChevronRight = () => (
  <svg className={css.chevronIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
  </svg>
);

const IconGrid = () => (
  <svg className={css.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
    />
  </svg>
);

const IconBuilding = () => (
  <svg className={css.advMetaIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </svg>
);

const IconVerified = () => (
  <svg className={css.advMetaIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const IconChat = () => (
  <svg className={css.advMetaIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>
);

const IconLocationSmall = () => (
  <svg
    style={{ width: '12px', height: '12px', color: 'var(--corail)', flexShrink: 0 }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

const IconChevronSmall = () => (
  <svg
    style={{ width: '14px', height: '14px' }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
  </svg>
);

/* ============================================
   COMPOSANT : GALERIE GRID
============================================ */

const GalleryGrid = ({ images, title, listing, onOpenPhoto }) => {
  const hasImages = images && images.length > 0;
  const mainImage = hasImages ? images[0] : null;
  const subImages = hasImages ? images.slice(1, 3) : [];

  if (!hasImages) {
    return (
      <section className={css.gallerySection}>
        <div className={css.galleryPlaceholder}>
          <span>Aucune image disponible</span>
          <AvailabilityNotice listing={listing} overlay className={css.photoAvailability} />
        </div>
      </section>
    );
  }

  const getVariants = img => Object.keys(img?.attributes?.variants || {});

  return (
    <section className={css.gallerySection}>
      <div className={css.galleryGrid}>
        <div className={css.imgMainFrame}>
          <button
            type="button"
            className={css.imgMain}
            onClick={() => onOpenPhoto(0)}
            aria-label="Agrandir la photo principale"
          >
            <ResponsiveImage
              rootClassName={css.galleryImg}
              alt={`${title} - Photo principale`}
              image={mainImage}
              variants={getVariants(mainImage)}
            />
            <div className={css.imgOverlay} />
          </button>
          <AvailabilityNotice listing={listing} overlay className={css.photoAvailability} />
        </div>
        {subImages.map((img, index) => (
          <button
            type="button"
            key={index}
            className={css.imgSub}
            onClick={() => onOpenPhoto(index + 1)}
            aria-label={`Agrandir la photo ${index + 2}`}
          >
            <ResponsiveImage
              rootClassName={css.galleryImg}
              alt={`${title} - Photo ${index + 2}`}
              image={img}
              variants={getVariants(img)}
            />
            <div className={css.imgOverlay} />
          </button>
        ))}
      </div>
      {images.length > 1 && (
        <div className={css.galleryActions}>
          <button className={css.btnGlass} onClick={() => onOpenPhoto(0)}>
            <IconGrid />
            Voir les {images.length} photos
          </button>
        </div>
      )}
    </section>
  );
};

/* ============================================
   COMPOSANT : PHOTO LIGHTBOX
============================================ */

const PhotoLightbox = ({ images, startIndex, title, onClose }) => {
  const [index, setIndex] = useState(startIndex || 0);

  useEffect(() => {
    setIndex(startIndex || 0);
  }, [startIndex]);

  useEffect(() => {
    const handleKey = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') setIndex(i => Math.max(0, i - 1));
      if (e.key === 'ArrowRight') setIndex(i => Math.min(images.length - 1, i + 1));
    };
    document.addEventListener('keydown', handleKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prev;
    };
  }, [images.length, onClose]);

  if (!images || images.length === 0) return null;
  const current = images[index];
  const variants = Object.keys(current?.attributes?.variants || {});

  const prev = () => setIndex(i => Math.max(0, i - 1));
  const next = () => setIndex(i => Math.min(images.length - 1, i + 1));

  return (
    <div className={css.lightbox} role="dialog" aria-modal="true" onClick={onClose}>
      <button className={css.lightboxClose} onClick={onClose} aria-label="Fermer">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          width="24"
          height="24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
      <div className={css.lightboxCounter}>
        {index + 1} / {images.length}
      </div>
      <button
        className={`${css.lightboxNav} ${css.lightboxNavLeft}`}
        onClick={e => {
          e.stopPropagation();
          prev();
        }}
        disabled={index === 0}
        aria-label="Photo précédente"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          width="28"
          height="28"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div className={css.lightboxContent} onClick={e => e.stopPropagation()}>
        <ResponsiveImage
          rootClassName={css.lightboxImage}
          alt={`${title} - Photo ${index + 1}`}
          image={current}
          variants={variants}
        />
      </div>
      <button
        className={`${css.lightboxNav} ${css.lightboxNavRight}`}
        onClick={e => {
          e.stopPropagation();
          next();
        }}
        disabled={index === images.length - 1}
        aria-label="Photo suivante"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          width="28"
          height="28"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

/* ============================================
   COMPOSANT : HIGHLIGHTS BAR
============================================ */

const HighlightsBar = ({ publicData, price, intl }) => {
  const { seatedStations, areaSize } = publicData || {};
  const lowestTier = lowestCommitmentPrice(getCommitmentPrices(publicData));

  // formatMoney throws when price isn't a proper Money instance, which
  // can happen with cached/partially-hydrated state on the server.
  // Treat that case as "no price" rather than crashing the whole page.
  let formattedPrice = null;
  if (price) {
    try {
      formattedPrice = formatMoney(intl, price);
    } catch (e) {
      formattedPrice = null;
    }
  }

  const highlights = [
    areaSize && { value: `${areaSize}`, label: 'm²' },
    seatedStations && { value: `${seatedStations}`, label: 'postes' },
    formattedPrice && {
      value: `${lowestTier ? 'Dès ' : ''}${formattedPrice}`,
      label: `${priceUnit(publicData)}${lowestTier ? ` · ${lowestTier.months} mois` : ''}`,
    },
  ].filter(Boolean);

  if (highlights.length === 0) {
    return null;
  }

  return (
    <div className={css.highlightsBar}>
      {highlights.map((item, index) => (
        <div key={index} className={css.highlightItem}>
          <strong className={css.highlightValue}>{item.value}</strong>
          <span className={css.highlightLabel}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

/* ============================================
   COMPOSANT : DETAILS GRID
============================================ */

const DetailsGrid = ({ publicData, metadata, listingFieldConfigs, currentCategories, intl }) => {
  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const listingType = publicData.listingType;
  // These two are already rendered prominently in HighlightsBar, so
  // skip them here to avoid showing the same number twice.
  const isRenderedElsewhere = key => key === 'seatedStations' || key === 'areaSize';

  const details = fieldsForOffer(listingFieldConfigs, publicData).reduce((acc, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    if (
      isRenderedElsewhere(key) ||
      (key === 'minCommitment' && getCommitmentPrices(publicData).length)
    )
      return acc;
    if (!showConfig.isDetail) return acc;
    if (!isFieldForListingType(listingType, config)) return acc;
    if (!isFieldForCategory(currentCategories, config)) return acc;

    const scope = config.scope || 'public';
    const source = scope === 'metadata' ? metadata : publicData;
    // For enum fields, a user-added "+ Autre" value is stored in a
    // sibling `<key>Custom` because the API drops unknown enum values.
    const rawValue =
      source?.[key] != null && source[key] !== '' ? source[key] : source?.[`${key}Custom`];
    if (rawValue == null || rawValue === '') return acc;

    let displayValue = null;
    if (schemaType === 'enum') {
      const opt = enumOptions?.find(o => `${o.option}` === `${rawValue}`);
      // Fall back to the raw value when the user picked a custom option
      // that isn't in the Console-defined enumOptions list.
      displayValue = opt?.label || `${rawValue}`;
    } else if (schemaType === 'boolean') {
      displayValue = rawValue
        ? intl.formatMessage({ id: 'SearchPage.detailYes' })
        : intl.formatMessage({ id: 'SearchPage.detailNo' });
    } else if (
      schemaType === 'long' ||
      schemaType === 'text' ||
      schemaType === 'shortText' ||
      schemaType === 'longText'
    ) {
      // Plain text and number fields render their value as-is. Text
      // covers free-form entries like "RDC" or "RDC + 1" for Étage.
      displayValue = `${rawValue}`.trim();
    }

    if (!displayValue) return acc;
    return acc.concat({ key, label: showConfig.label || key, value: displayValue });
  }, []);

  // Drop any floorsNumber row produced by the config-driven loop above;
  // we render Étage explicitly below so it can't get silently filtered
  // out by listing-type or category restrictions on the asset config.
  const detailsWithoutFloor = details.filter(d => d.key !== 'floorsNumber');

  // Resolve Étage directly from publicData. Independent of
  // listingFieldConfigs — if a value is saved we surface it, period.
  const floorRaw =
    publicData?.floorsNumber != null && publicData.floorsNumber !== ''
      ? publicData.floorsNumber
      : publicData?.floorsNumberCustom;
  const floorDisplay =
    floorRaw != null && `${floorRaw}`.trim() !== '' ? `${floorRaw}`.trim() : null;
  const floorLabel =
    listingFieldConfigs.find(c => c.key === 'floorsNumber')?.showConfig?.label || 'Étage';

  if (detailsWithoutFloor.length === 0 && !floorDisplay) {
    return null;
  }

  return (
    <div className={css.sectionBlock}>
      <h2 className={css.sectionTitle}>Détails techniques</h2>
      <div className={css.detailsGrid}>
        {floorDisplay ? (
          <div key="floorsNumber" className={css.detailRow}>
            <span className={css.detailLabel}>{floorLabel}</span>
            <span className={css.detailVal}>{floorDisplay}</span>
          </div>
        ) : null}
        {detailsWithoutFloor.map(detail => (
          <div key={detail.key} className={css.detailRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span className={css.detailVal}>{detail.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

/* ============================================
   COMPOSANT : AMENITIES PILLS
============================================ */

const AmenitiesPills = ({ publicData, metadata, listingFieldConfigs, currentCategories }) => {
  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const listingType = publicData.listingType;

  const groups = listingFieldConfigs.reduce((acc, config) => {
    if (config.schemaType !== SCHEMA_TYPE_MULTI_ENUM) return acc;
    if (!isFieldForListingType(listingType, config)) return acc;
    if (!isFieldForCategory(currentCategories, config)) return acc;

    const scope = config.scope || 'public';
    const source = scope === 'metadata' ? metadata : publicData;
    const baseKeys = Array.isArray(source?.[config.key]) ? source[config.key] : [];
    const customKeys = Array.isArray(source?.[`${config.key}Custom`])
      ? source[`${config.key}Custom`]
      : [];
    const selectedKeys = [...baseKeys, ...customKeys];
    if (selectedKeys.length === 0) return acc;

    // Render every selected value, even ones the user added inline that
    // don't exist in the Console enumOptions. When a value matches a
    // known option, prefer its configured label; otherwise fall back
    // to the raw key (which is what the user typed).
    const optionsByKey = {};
    (config.enumOptions || []).forEach(opt => {
      optionsByKey[`${opt.option}`] = opt.label;
    });
    const items = selectedKeys.map(rawKey => {
      const k = `${rawKey}`;
      return { key: k, label: optionsByKey[k] || k };
    });

    if (items.length === 0) return acc;

    return acc.concat({
      key: config.key,
      title: config.showConfig?.label || config.key,
      items,
    });
  }, []);

  if (groups.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionBlock}>
      <h2 className={css.sectionTitle}>Ce que propose cet espace</h2>
      <div className={css.amenitiesSection}>
        {groups.map(group => (
          <div key={group.key} className={css.amenitiesGroup}>
            <h4 className={css.amenitiesGroupTitle}>{group.title}</h4>
            <div className={css.pillsWrapper}>
              {group.items.map(item => (
                <span key={item.key} className={css.pill}>
                  {item.label}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

/* ============================================
   COMPOSANT : BOOKING WIDGET (STICKY)
============================================ */

const BookingWidget = ({
  price,
  intl,
  author,
  onContactClick,
  onVisitClick,
  manageVisitsParams,
  hasVisitSlots,
  isOwnListing,
  spaceAvailability,
  listingTitle,
  areaSize,
  seatedStations,
  priceType,
  sale,
  commitmentLabel,
  chargesLabel,
  totalSeatsLabel,
  lowestCommitmentMonths,
  officeLabel,
  officeSelector,
}) => {
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const authorName = userDisplayNameAsString(author, 'Annonceur');
  const formattedPrice = price ? formatMoney(intl, price) : 'Prix sur demande';

  const profileImage = author?.profileImage;
  const profileImageVariants = profileImage?.attributes?.variants || {};
  const profileImageUrl =
    profileImageVariants['square-small2x']?.url ||
    profileImageVariants['square-small']?.url ||
    null;

  const authorPublicData = author?.attributes?.profile?.publicData || {};
  const contact = getAdvertiserProfile(authorPublicData);
  const phoneNumber = contact.publicPhone || null;
  const emailAddress = contact.publicEmail || null;

  const mailtoSubject = encodeURIComponent(
    `[Cobuco] Demande à propos de : ${listingTitle || 'votre annonce'}`
  );
  const mailtoBody = encodeURIComponent(
    `Bonjour,\n\nJe vous contacte via Cobuco à propos de votre annonce "${listingTitle || ''}".\n\n`
  );

  return (
    <div className={css.bookingWidget}>
      <div className={css.widgetHeader}>
        {officeLabel && (
          <div className={css.selectedOffice}>
            <span>Le bureau que vous consultez</span>
            <strong>{officeLabel}</strong>
          </div>
        )}
        {lowestCommitmentMonths && <div className={css.pricePrefix}>À partir de</div>}
        <div className={css.widgetPrice}>
          {formattedPrice}
          {price && (
            <sub>
              {sale ? 'Prix de vente' : priceType === 'seat' ? '/ poste / mois HT' : '/ mois HT'}
            </sub>
          )}
        </div>
        {!sale &&
          (priceType === 'seat' ||
            commitmentLabel ||
            lowestCommitmentMonths ||
            chargesLabel ||
            totalSeatsLabel) && (
            <div className={css.widgetPriceDetail}>
              {priceType === 'seat' && <span>Prix unitaire pour 1 poste</span>}
              {totalSeatsLabel && <span>{totalSeatsLabel}</span>}
              {chargesLabel && <span>{chargesLabel}</span>}
              {lowestCommitmentMonths ? (
                <span>Pour {lowestCommitmentMonths} mois d’engagement</span>
              ) : (
                commitmentLabel && <span>Engagement {commitmentLabel}</span>
              )}
            </div>
          )}
        {lowestCommitmentMonths && (
          <a className={css.allPricesLink} href="#tarifs-engagement">
            Voir tous les tarifs
          </a>
        )}
      </div>

      <div className={css.widgetBody}>
        <div className={css.widgetStats}>
          {seatedStations && (
            <div className={css.widgetStat}>
              <strong>{seatedStations}</strong>
              <span>Postes</span>
            </div>
          )}
          {areaSize && (
            <div className={css.widgetStat}>
              <strong>{areaSize} m²</strong>
              <span>Surface</span>
            </div>
          )}
        </div>

        <NamedLink name="ProfilePage" params={{ id: author?.id?.uuid }} className={css.widgetAdv}>
          {profileImageUrl ? (
            <img src={profileImageUrl} className={css.widgetAdvLogo} alt={authorName} />
          ) : (
            <div className={css.widgetAdvLogoPlaceholder}>{authorName?.charAt(0)}</div>
          )}
          <div className={css.widgetAdvInfo}>
            <small>Hôte</small>
            <strong>{authorName}</strong>
          </div>
          <IconChevronRight />
        </NamedLink>

        {isOwnListing ? (
          <>
            <div className={css.ownListingNotice}>C'est votre annonce</div>
            {manageVisitsParams ? (
              <NamedLink
                name="EditListingPage"
                params={manageVisitsParams}
                className={css.manageVisitsLink}
              >
                <IconVisitCalendar />
                {hasVisitSlots
                  ? 'Modifier mes créneaux de visite'
                  : 'Proposer des créneaux de visite'}
              </NamedLink>
            ) : null}
          </>
        ) : (
          <>
            <button
              className={css.btnCta}
              disabled={!spaceAvailability.available}
              onClick={() => setShowContactInfo(prev => !prev)}
            >
              <IconMessage />
              {showContactInfo ? 'Masquer les coordonnées' : "Contacter l'annonceur"}
            </button>

            {showContactInfo && spaceAvailability.available && (
              <div className={css.contactInfoBox}>
                {phoneNumber && (
                  <a
                    href="#"
                    className={css.contactInfoItem}
                    onClick={e => {
                      e.preventDefault();
                      setShowPhoneModal(true);
                    }}
                  >
                    <span className={css.contactInfoIcon}>📞</span>
                    <span>{phoneNumber}</span>
                  </a>
                )}
                {emailAddress && (
                  <a
                    href={`mailto:${emailAddress}?subject=${mailtoSubject}&body=${mailtoBody}`}
                    className={css.contactInfoItem}
                  >
                    <span className={css.contactInfoIcon}>✉️</span>
                    <span>{emailAddress}</span>
                  </a>
                )}
                {!phoneNumber && !emailAddress && (
                  <p className={css.contactInfoHint}>
                    Cet annonceur n'a pas encore renseigné ses coordonnées. Utilisez la messagerie
                    Cobuco ci-dessous.
                  </p>
                )}
                {(phoneNumber || emailAddress) && (
                  <p className={css.contactInfoHint}>
                    Mentionnez <strong>Cobuco</strong> lors de votre prise de contact
                  </p>
                )}
              </div>
            )}

            {showPhoneModal && phoneNumber && (
              <div className={css.phoneModalOverlay} onClick={() => setShowPhoneModal(false)}>
                <div className={css.phoneModal} onClick={e => e.stopPropagation()}>
                  <p className={css.phoneModalTitle}>Avant d'appeler</p>
                  <p className={css.phoneModalText}>
                    Pensez à mentionner que vous appelez depuis <strong>Cobuco</strong> à propos de
                    l'annonce <strong>"{listingTitle || ''}"</strong>.
                  </p>
                  <a href={`tel:${phoneNumber}`} className={css.phoneModalButton}>
                    Appeler le {phoneNumber}
                  </a>
                  <button
                    type="button"
                    className={css.phoneModalClose}
                    onClick={() => setShowPhoneModal(false)}
                  >
                    Annuler
                  </button>
                </div>
              </div>
            )}

            {onVisitClick ? (
              <button
                className={css.btnVisit}
                disabled={!spaceAvailability.available}
                onClick={onVisitClick}
              >
                <IconVisitCalendar />
                Planifier une visite
              </button>
            ) : null}

            <button
              className={css.btnSecondary}
              disabled={!spaceAvailability.available}
              onClick={onContactClick}
            >
              <IconMessage />
              Envoyer un message via la messagerie Cobuco
            </button>
          </>
        )}
        {officeSelector}
      </div>

      <div className={css.widgetTrust}>
        <div className={css.trustItem}>
          <IconCheck />
          Mise en relation gratuite & sécurisée
        </div>
        <div className={css.trustItem}>
          <IconCheck />
          Données confidentielles & protégées
        </div>
        <div className={css.trustItem}>
          <IconCheck />
          Aucune commission sur la transaction
        </div>
      </div>
    </div>
  );
};

/* ============================================
   COMPOSANT : ADVERTISER SECTION
============================================ */

const AdvertiserSection = ({ author }) => {
  const authorName = userDisplayNameAsString(author, 'Annonceur');
  const bio = author?.attributes?.profile?.bio || null;

  const profileImage = author?.profileImage;
  const profileImageVariants = profileImage?.attributes?.variants || {};
  const profileImageUrl =
    profileImageVariants['square-small2x']?.url ||
    profileImageVariants['square-small']?.url ||
    null;

  return (
    <div className={css.advertiserSection}>
      {profileImageUrl ? (
        <img src={profileImageUrl} className={css.advAvatar} alt={authorName} />
      ) : (
        <div className={css.advAvatarPlaceholder}>{authorName?.charAt(0)}</div>
      )}
      <div className={css.advBody}>
        <div className={css.advLabel}>Hôte de cet espace</div>
        <div className={css.advName}>{authorName}</div>
        {bio && <p className={css.advDescription}>{bio}</p>}
        <NamedLink name="ProfilePage" params={{ id: author?.id?.uuid }} className={css.advLink}>
          Voir la page de l'annonceur
          <IconChevronRight />
        </NamedLink>
      </div>
    </div>
  );
};

/* ============================================
   COMPOSANT : ESPACES SIMILAIRES
============================================ */

// Données statiques en attendant une intégration API
const TYPE_LABELS = {
  bureau: 'Bureau Opéré',
  coworking: 'Coworking',
  'sous-location': 'Sous-Location',
  reunion: 'Salle de Réunion',
};

const SimilarListings = ({ listings, listingTypes, intl }) => {
  if (!listings || listings.length === 0) return null;

  return (
    <section className={css.similairesSection}>
      <div className={css.similairesHeader}>
        <h2 className={css.similairesTitle}>Espaces similaires</h2>
        <NamedLink name="NosAnnonces2Page" className={css.seeAll}>
          Voir tout
          <IconChevronSmall />
        </NamedLink>
      </div>
      <div className={css.similarGrid}>
        {listings.map(listing => {
          const { title = '', price, publicData = {} } = listing.attributes || {};
          const { listingType, location, areaSize, seatedStations } = publicData;
          const badge =
            listingTypes.find(type => type.listingType === listingType)?.label ||
            TYPE_LABELS[listingType] ||
            'Espace';
          const cityLabel = location?.city || location?.streetCity || '';
          const formattedPrice =
            price && intl
              ? intl.formatNumber(price.amount / 100, {
                  style: 'currency',
                  currency: price.currency,
                  maximumFractionDigits: 0,
                })
              : null;
          const area = areaSize
            ? `${areaSize} m²`
            : seatedStations
            ? `${seatedStations} postes`
            : null;

          // Get best available image URL
          const firstImage = listing.images?.[0];
          const variants = firstImage?.attributes?.variants || {};
          const imgUrl =
            variants['listing-card']?.url ||
            variants['listing-card-2x']?.url ||
            variants['landscape-crop']?.url ||
            variants['scaled-medium']?.url ||
            null;

          const slug = title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');

          return (
            <NamedLink
              key={listing.id.uuid}
              name="ListingPage"
              params={{ id: listing.id.uuid, slug }}
              className={css.similarCard}
            >
              <div className={css.similarImgWrap}>
                {imgUrl ? (
                  <img src={imgUrl} className={css.similarImg} alt={title} loading="lazy" />
                ) : (
                  <div className={css.similarImgPlaceholder} />
                )}
                <AvailabilityNotice listing={listing} compact overlay />
              </div>
              <div className={css.similarBody}>
                <div className={css.similarBadge}>{badge}</div>
                <div className={css.similarTitle}>{title}</div>
                {cityLabel && (
                  <div className={css.similarMeta}>
                    <IconLocationSmall />
                    {cityLabel}
                  </div>
                )}
                <div className={css.similarFooter}>
                  {formattedPrice && (
                    <div className={css.similarPrice}>
                      {getCommitmentPrices(publicData).length ? 'À partir de ' : ''}
                      {formattedPrice}{' '}
                      <span>
                        {priceUnit(publicData)}
                        {getCommitmentPrices(publicData).length
                          ? ` · dès ${
                              lowestCommitmentPrice(getCommitmentPrices(publicData)).months
                            } mois`
                          : ''}
                      </span>
                    </div>
                  )}
                  {area && <div className={css.similarArea}>{area}</div>}
                </div>
              </div>
            </NamedLink>
          );
        })}
      </div>
    </section>
  );
};

/* ============================================
   COMPOSANT PRINCIPAL : PAGE D'ANNONCE
============================================ */

export const ListingPageMarketplaceComponent = props => {
  const [mounted, setMounted] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [showVisitModal, setShowVisitModal] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setMounted(true);
  }, []);

  // A switch changes the listing UUID: reset overlays and never carry a draft
  // visit or message from the previous office to the newly selected one.
  useEffect(() => {
    const hash =
      props.location?.hash ?? (typeof window !== 'undefined' ? window.location?.hash : '');
    setShowInquiryModal(hash === '#contact');
    setShowVisitModal(hash === '#visite');
    setShowContactInfo(false);
    setLightboxIndex(null);
  }, [props.params?.id, props.location?.hash]);

  const {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    intl,
    onManageDisableScrolling,
    params: rawParams,
    location,
    scrollingDisabled,
    showListingError,
    reviews = [],
    history,
    config,
    routeConfiguration,
    showOwnListingsOnly,
    onSendInquiry,
    sendInquiryInProgress,
    sendInquiryError,
  } = props;

  const listingConfig = config.listing;
  const listingId = new UUID(rawParams.id);
  const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
  const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
  const currentListing =
    isPendingApprovalVariant || isDraftVariant || showOwnListingsOnly
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));

  const spaceAvailability = useListingAvailability(currentListing);
  const listingUuid = currentListing?.id?.uuid;
  const similarListingType = currentListing.attributes.publicData?.listingType;
  const offerType = getOfferType(currentListing.attributes.publicData);
  const isSaved = useSelector(state => selectIsFavorite(state, listingUuid));
  const fullState = useSelector(state => state);
  const similarKey = similarListingsKey(listingUuid, similarListingType, offerType);
  const similarListingsRefs =
    fullState.ListingPage?.similarListingsKey === similarKey
      ? fullState.ListingPage.similarListingsRefs
      : [];
  const similarListings = getMarketplaceEntities(fullState, similarListingsRefs);
  const locationKey = getListingLocationKey(currentListing);
  const officeCollectionKey = locationListingsKey(currentListing);
  const locationOffices =
    fullState.ListingPage?.locationListingsKey === officeCollectionKey
      ? fullState.ListingPage.locationListings || []
      : [];
  const listingAuthorId = currentListing?.author?.id?.uuid;
  const currentListingState = currentListing?.attributes?.state;

  useEffect(() => {
    if (officeCollectionKey && listingAuthorId && currentListingState === 'published') {
      dispatch(fetchLocationListings(currentListing));
    }
    // Re-fetch only when the office, grouping identity, author or publication changes.
  }, [dispatch, officeCollectionKey, listingAuthorId, currentListingState]);

  useEffect(() => {
    if (listingUuid && similarListingType) {
      dispatch(fetchSimilarListings(listingUuid, similarListingType, offerType));
    }
  }, [dispatch, listingUuid, similarListingType, offerType]);

  useEffect(() => {
    if (!mounted || currentListing?.attributes?.state !== 'published') return;
    return startListingVisit(
      currentListing.id.uuid,
      currentListing?.author?.id?.uuid,
      currentUser?.id?.uuid
    );
    // Authentication is checked again on the server. Loading the user profile
    // must not start a second visit to the same listing.
  }, [mounted, currentListing?.id?.uuid, currentListing?.attributes?.state]);

  const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
  const params = { slug: listingSlug, ...rawParams };

  const isApproved =
    currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

  const pendingIsApproved = isPendingApprovalVariant && isApproved;
  const pendingOtherUsersListing =
    (isPendingApprovalVariant || isDraftVariant) &&
    showListingError &&
    showListingError.status === 403;
  const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

  if (shouldShowPublicListingPage) {
    return <NamedRedirect name="ListingPageMarketplace" params={params} search={location.search} />;
  }

  const topbar = <TopbarContainer />;

  if (showListingError && showListingError.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  } else if (showListingError) {
    return <ErrorPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  } else if (!currentListing.id) {
    return <LoadingPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  }

  const {
    description = '',
    geolocation = null,
    price = null,
    title = '',
  } = currentListing.attributes;
  const publicData = officePublicData(currentListing);

  const authorAvailable = currentListing && currentListing.author;
  const currentAuthor = authorAvailable ? currentListing.author : null;
  const ensuredAuthor = ensureUser(currentAuthor);
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, 'Anonyme');
  const isOwnListing = currentUser?.id?.uuid === ensuredAuthor?.id?.uuid;

  const { listingType, location: listingLocation } = publicData;
  const isLocationOffice =
    !!locationKey &&
    (publicData.wsNumBureau != null || locationOffices.length > 1 || !!location.state?.fromGroupId);
  const displayedTitle = isLocationOffice ? officeTitle(currentListing) : title;
  const locationName = isLocationOffice ? getListingLocationName(currentListing) : null;
  const listingsPath = createResourceLocatorString('NosAnnonces2Page', routeConfiguration, {}, {});
  const returnToListings = locationListingsReturn(
    location.state,
    listingsPath,
    listingUuid,
    locationKey
  );
  const handleSelectOffice = office => {
    const path = createResourceLocatorString(
      'ListingPage',
      routeConfiguration,
      { id: office.id.uuid, slug: createSlug(office.attributes.title || '') },
      {}
    );
    history.push(path, {
      fromListings: `${listingsPath}${returnToListings.search}`,
      fromGroupId: returnToListings.state.expandedGroupId,
      fromListingsPage: returnToListings.state.listingsPage,
    });
  };
  const validListingTypes = listingConfig.listingTypes;
  const foundListingTypeConfig = validListingTypes.find(conf => conf.listingType === listingType);
  const listingTypeLabel = foundListingTypeConfig?.label || listingType;

  // Pricing labels follow what the seller picked in the wizard: 'month'
  // means a flat monthly price, 'seat' means per workstation per month.
  const sale = isSale(publicData);
  const priceType = sale ? 'total' : publicData?.priceType === 'seat' ? 'seat' : 'month';
  const commitmentPrices = sale ? [] : getCommitmentPrices(publicData);
  const lowestTier = lowestCommitmentPrice(commitmentPrices);

  // When the seller priced per seat AND told us how many seats there
  // are, compute and show the total monthly estimate alongside the
  // unit price so visitors don't have to do the math themselves.
  const totalSeatsLabel = (() => {
    if (priceType !== 'seat') return null;
    const seats = Number(publicData?.seatedStations);
    if (!Number.isFinite(seats) || seats <= 0) return null;
    if (!price || typeof price.amount !== 'number' || !price.currency) return null;
    try {
      const total = new sdkTypes.Money(price.amount * seats, price.currency);
      const totalFormatted = formatMoney(intl, total);
      return `Soit ${totalFormatted} / mois pour ${seats} poste${seats > 1 ? 's' : ''}`;
    } catch (e) {
      return null;
    }
  })();

  // Boolean charges-included toggle from the pricing step. Only render
  // a label when the seller actually answered (true/false); a null
  // means "not set" → nothing displayed.
  const chargesLabel =
    publicData?.chargesIncluded === true
      ? 'Charges comprises'
      : publicData?.chargesIncluded === false
      ? 'Hors charges'
      : null;

  // Resolve the human label for the seller's selected Engagement minimum,
  // falling back to the raw value (incl. "+ Autre" customs).
  const minCommitmentField = (listingConfig.listingFields || []).find(
    f => f.key === 'minCommitment'
  );
  const minCommitmentRaw =
    publicData?.minCommitment != null && publicData.minCommitment !== ''
      ? publicData.minCommitment
      : publicData?.minCommitmentCustom;
  const commitmentLabel = (() => {
    if (commitmentPrices.length) return null;
    if (minCommitmentRaw == null || minCommitmentRaw === '') return null;
    const opt = minCommitmentField?.enumOptions?.find(o => `${o.option}` === `${minCommitmentRaw}`);
    return opt?.label || `${minCommitmentRaw}`;
  })();

  const categoryConfiguration = config.categoryConfiguration;
  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration || {};
  const categoriesObj = categoryPrefix
    ? pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig)
    : {};
  const currentCategories = Object.values(categoriesObj);

  const streetCity = listingLocation?.streetCity || '';
  const images = currentListing.images || [];

  const { formattedPrice } = priceData(price, config.currency, intl);

  const handleContactClick = () => {
    if (!getListingAvailability(currentListing).available) return;
    if (!isAuthenticated) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };
      history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}), state);
      return;
    }
    trackListingClick(currentListing?.id?.uuid, 'contact');
    setShowInquiryModal(true);
  };

  // Visits are offered only when the advertiser opened slots in the listing editor.
  const visitAvailability = normalizeVisitAvailability(publicData?.visitAvailability);
  const manageVisitsParams = currentListing.id
    ? { id: currentListing.id.uuid, slug: listingSlug, type: 'edit', tab: 'visits' }
    : null;

  const handleVisitClick = () => {
    if (!getListingAvailability(currentListing).available) return;
    if (!isAuthenticated) {
      const state = { from: `${location.pathname}${location.search}#visite` };
      history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}), state);
      return;
    }
    trackListingClick(currentListing?.id?.uuid, 'contact');
    setShowVisitModal(true);
  };

  // The visit is an inquiry whose slot is kept in protectedData.visitRequest,
  // so both parties can add it to their calendar from the conversation.
  const handleSendVisitRequest = ({ visitRequest, message }) => {
    if (!getListingAvailability(currentListing).available)
      return Promise.reject(new Error(spaceAvailability.label));
    return onSendInquiry(currentListing, message, { visitRequest });
  };

  const handleViewVisitConversation = txId => {
    setShowVisitModal(false);
    const path = txId?.uuid
      ? createResourceLocatorString('OrderDetailsPage', routeConfiguration, { id: txId.uuid }, {})
      : createResourceLocatorString('InboxPage', routeConfiguration, { tab: 'orders' }, {});
    history.push(path);
  };

  const handleSendInquiry = values => {
    if (!getListingAvailability(currentListing).available) return;
    const { message } = values;
    onSendInquiry(currentListing, message.trim())
      .then(txId => {
        setShowInquiryModal(false);
        history.push(
          createResourceLocatorString('InboxPage', routeConfiguration, { tab: 'orders' }, {})
        );
      })
      .catch(() => {
        // L'erreur est affichée dans le formulaire
      });
  };

  const handleSaveClick = () => {
    if (listingUuid) dispatch(toggleFavorite(listingUuid));
  };

  const handleShareClick = () => {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({ title: currentListing?.attributes?.title || 'Cobuco', url });
    } else {
      navigator.clipboard.writeText(url).then(() => alert('Lien copié !'));
    }
  };

  return (
    <Page
      {...listingPageMetadata(currentListing, config.marketplaceRootURL)}
      scrollingDisabled={scrollingDisabled}
      author={authorDisplayName}
    >
      <TopbarContainer />

      <main className={css.main}>
        {/* Navigation */}
        <nav className={css.topNav}>
          <div className={css.navLeft}>
            <div className={css.breadcrumb}>
              <NamedLink name="LandingPage" className={css.breadcrumbLink}>
                Accueil
              </NamedLink>
              <span className={css.breadcrumbSep}>›</span>
              <NamedLink
                name="NosAnnonces2Page"
                to={returnToListings}
                className={css.breadcrumbLink}
              >
                Annonces
              </NamedLink>
              <span className={css.breadcrumbSep}>›</span>
              <span>{streetCity || 'Paris'}</span>
            </div>
          </div>
          <div className={css.navActions}>
            <button className={css.btnGhost} onClick={handleShareClick}>
              <IconShare />
              Partager
            </button>
            <button
              className={classNames(css.btnGhost, css.btnSave, { [css.btnSaved]: isSaved })}
              onClick={handleSaveClick}
            >
              <IconHeart filled={isSaved} />
              Sauvegarder
            </button>
          </div>
        </nav>

        {isLocationOffice && (
          <div className={css.locationReturn}>
            <NamedLink name="NosAnnonces2Page" to={returnToListings} className={css.breadcrumbLink}>
              ← Retour aux bureaux{locationName ? ` · ${locationName}` : ''}
            </NamedLink>
          </div>
        )}

        {/* Hero Header */}
        <header className={css.heroHeader}>
          <div className={css.heroTitleBlock}>
            <div className={css.badgesRow}>
              <span className={css.badgeType}>{offerLabel(publicData)}</span>
              {listingTypeLabel && <span className={css.badgeType}>{listingTypeLabel}</span>}
            </div>
            {locationName && <div className={css.locationName}>{locationName}</div>}
            <h1 className={css.adTitle}>{displayedTitle}</h1>
            {streetCity && (
              <div className={css.adLocation}>
                <IconLocation />
                {streetCity}
              </div>
            )}
          </div>
          {price && (
            <div className={css.heroPriceBlock}>
              {lowestTier && <div className={css.pricePrefix}>À partir de</div>}
              <div className={css.heroPrice}>{formattedPrice}</div>
              <div className={css.heroPriceSub}>
                {sale
                  ? 'Prix de vente'
                  : priceType === 'seat'
                  ? '/ poste / mois HT'
                  : 'par mois HT'}
              </div>
              {totalSeatsLabel && <div className={css.heroPriceNote}>{totalSeatsLabel}</div>}
              {lowestTier && (
                <div className={css.heroPriceNote}>Pour {lowestTier.months} mois d’engagement</div>
              )}
              {!sale && (chargesLabel || commitmentLabel) && (
                <div className={css.heroPriceNote}>
                  {[chargesLabel, commitmentLabel ? `Engagement ${commitmentLabel}` : null]
                    .filter(Boolean)
                    .join(' · ')}
                </div>
              )}
            </div>
          )}
        </header>

        <div className={css.mobileOfficeSwitcher}>
          <LocationOfficeSelector
            id="mobile-location-office-selector"
            currentListing={currentListing}
            listings={locationOffices}
            onSelect={handleSelectOffice}
          />
        </div>

        {/* Galerie */}
        <GalleryGrid
          images={images}
          title={title}
          listing={currentListing}
          onOpenPhoto={i => setLightboxIndex(i)}
        />

        {/* Lightbox fullscreen */}
        {lightboxIndex !== null && images && images.length > 0 && (
          <PhotoLightbox
            images={images}
            startIndex={lightboxIndex}
            title={title}
            onClose={() => setLightboxIndex(null)}
          />
        )}

        {/* Contenu principal */}
        <div className={css.contentLayout}>
          <div className={css.mainCol}>
            {/* Highlights */}
            <HighlightsBar publicData={publicData} price={price} intl={intl} />

            {commitmentPrices.length > 0 && (
              <section
                id="tarifs-engagement"
                className={css.sectionBlock}
                aria-labelledby="tarifs-engagement-title"
              >
                <h2 id="tarifs-engagement-title" className={css.sectionTitle}>
                  Tarifs selon la durée d’engagement
                </h2>
                <p className={css.tierDescription}>
                  Choisissez la durée qui vous convient. Chaque montant correspond à un loyer
                  mensuel HT{priceType === 'seat' ? ' par poste' : ''}.
                </p>
                <div className={css.tierList}>
                  {commitmentPrices.map(tier => (
                    <div className={css.tierItem} key={tier.months}>
                      <div className={css.tierTerm}>
                        <strong>{tier.months} mois</strong>
                        <span>d’engagement</span>
                      </div>
                      <div className={css.tierAmount}>
                        <strong>
                          {formatMoney(
                            intl,
                            new sdkTypes.Money(tier.amount, price?.currency || config.currency)
                          )}
                        </strong>
                        <span>{priceType === 'seat' ? 'HT / poste / mois' : 'HT / mois'}</span>
                        {priceType === 'seat' && Number(publicData.seatedStations) > 0 && (
                          <span>
                            Soit{' '}
                            {formatMoney(
                              intl,
                              new sdkTypes.Money(
                                tier.amount * Number(publicData.seatedStations),
                                price?.currency || config.currency
                              )
                            )}{' '}
                            / mois pour {publicData.seatedStations} postes
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                {chargesLabel && <p className={css.tierCharges}>{chargesLabel}</p>}
              </section>
            )}

            {/* Description */}
            {description && (
              <div className={css.sectionBlock}>
                <h2 className={css.sectionTitle}>Description de l'espace</h2>
                <div className={css.descriptionText}>
                  {description.split(/\n\n+/).map((para, i) => (
                    <p key={i}>{para.replace(/\n/g, ' ')}</p>
                  ))}
                </div>
              </div>
            )}

            {/* Détails techniques */}
            <DetailsGrid
              publicData={publicData}
              metadata={currentListing.attributes.metadata}
              listingFieldConfigs={listingConfig.listingFields}
              currentCategories={currentCategories}
              intl={intl}
            />

            {/* Équipements */}
            <AmenitiesPills
              publicData={publicData}
              metadata={currentListing.attributes.metadata}
              listingFieldConfigs={listingConfig.listingFields}
              currentCategories={currentCategories}
            />

            {/* Carte */}
            {geolocation && (
              <div className={css.sectionBlock}>
                <h2 className={css.sectionTitle}>Localisation</h2>
                <div className={css.mapContainer}>
                  <Map
                    center={geolocation}
                    address={streetCity}
                    zoom={15}
                    mapsConfig={config.maps}
                  />
                </div>
              </div>
            )}

            {/* Annonceur */}
            <div className={css.sectionBlock}>
              <h2 className={css.sectionTitle}>L'opérateur</h2>
              <AdvertiserSection author={ensuredAuthor} />
            </div>
          </div>

          {/* Widget sticky */}
          <aside className={css.sideCol}>
            <BookingWidget
              key={listingUuid}
              price={price}
              intl={intl}
              author={ensuredAuthor}
              onContactClick={handleContactClick}
              onVisitClick={visitAvailability ? handleVisitClick : null}
              manageVisitsParams={manageVisitsParams}
              hasVisitSlots={!!visitAvailability}
              isOwnListing={isOwnListing}
              spaceAvailability={spaceAvailability}
              listingTitle={title}
              areaSize={publicData.areaSize}
              seatedStations={publicData.seatedStations}
              priceType={priceType}
              sale={sale}
              commitmentLabel={commitmentLabel}
              chargesLabel={chargesLabel}
              totalSeatsLabel={totalSeatsLabel}
              lowestCommitmentMonths={lowestTier?.months}
              officeLabel={isLocationOffice ? displayedTitle : null}
              officeSelector={
                <LocationOfficeSelector
                  currentListing={currentListing}
                  listings={locationOffices}
                  onSelect={handleSelectOffice}
                />
              }
            />
          </aside>
        </div>

        {/* Mobile Bar */}
        {!isOwnListing && (
          <div className={css.mobileBar}>
            <div className={css.mobilePrice}>
              {lowestTier && <small>À partir de · {lowestTier.months} mois</small>}
              {formattedPrice || 'Prix sur demande'}
              {price && (
                <small>
                  {sale
                    ? 'Prix de vente'
                    : priceType === 'seat'
                    ? '/ poste / mois HT'
                    : '/ mois HT'}
                </small>
              )}
            </div>
            <div className={css.mobileActions}>
              {visitAvailability ? (
                <button
                  className={css.mobileVisit}
                  disabled={!spaceAvailability.available}
                  onClick={handleVisitClick}
                >
                  <IconVisitCalendar />
                  Visiter
                </button>
              ) : null}
              <button
                className={css.mobileCta}
                disabled={!spaceAvailability.available}
                onClick={handleContactClick}
              >
                {spaceAvailability.available ? 'Contacter' : 'Indisponible'}
              </button>
            </div>
          </div>
        )}

        <SimilarListings listings={similarListings} listingTypes={validListingTypes} intl={intl} />
      </main>

      <FooterContainer />

      <Modal
        id="ListingPage.inquiry"
        isOpen={showInquiryModal && spaceAvailability.available}
        onClose={() => setShowInquiryModal(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        {showInquiryModal && spaceAvailability.available ? (
          <InquiryForm
            key={listingUuid}
            formId="ListingPage.inquiry.form"
            onSubmit={handleSendInquiry}
            inProgress={sendInquiryInProgress}
            sendInquiryError={sendInquiryError}
            listingTitle={currentListing?.attributes?.title}
            authorDisplayName={authorDisplayName}
          />
        ) : null}
      </Modal>

      <Modal
        id="ListingPage.visitRequest"
        containerClassName={visitModalContainerClassName}
        isOpen={
          showVisitModal && !!visitAvailability && !isOwnListing && spaceAvailability.available
        }
        onClose={() => setShowVisitModal(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        {showVisitModal && spaceAvailability.available ? (
          <VisitRequestPanel
            key={listingUuid}
            availability={visitAvailability}
            listingTitle={title}
            authorDisplayName={authorDisplayName}
            timeZone={visitTimeZone(currentListing)}
            address={publicData?.location?.address || streetCity}
            listingUrl={
              typeof window !== 'undefined'
                ? `${window.location.origin}${window.location.pathname}`
                : null
            }
            onSubmit={handleSendVisitRequest}
            onViewConversation={handleViewVisitConversation}
            inProgress={sendInquiryInProgress}
            sendInquiryError={sendInquiryError}
          />
        ) : null}
      </Modal>
    </Page>
  );
};

/* ============================================
   COMPOSANT AMÉLIORÉ AVEC GESTION DES ACCÈS
============================================ */

const EnhancedListingPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  const showListingError = props.showListingError;
  const isVariant = props.params?.variant != null;
  const currentUser = props.currentUser;

  if (isForbiddenError(showListingError) && !isVariant && !currentUser) {
    return (
      <NamedRedirect
        name="SignupPage"
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const isUnauthorizedUser = currentUser && !isUserAuthorized(currentUser);
  const hasNoViewingRights = currentUser && !hasPermissionToViewData(currentUser);
  const hasUserPendingApprovalError = isErrorUserPendingApproval(showListingError);

  if ((isPrivateMarketplace && isUnauthorizedUser) || hasUserPendingApprovalError) {
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_USER_PENDING_APPROVAL }}
      />
    );
  } else if (
    (hasNoViewingRights && isForbiddenError(showListingError)) ||
    isErrorNoViewingPermission(showListingError)
  ) {
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_VIEW_LISTINGS }}
      />
    );
  }

  return (
    <ListingPageMarketplaceComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      showOwnListingsOnly={hasNoViewingRights}
      {...props}
    />
  );
};

/* ============================================
   CONNEXION REDUX
============================================ */

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
    inquiryModalOpenForListingId,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    inquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onSendInquiry: (listing, message, protectedData) =>
    dispatch(sendInquiry(listing, message, protectedData)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone, options) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone, options)),
});

const ListingPageMarketplace = compose(connect(mapStateToProps, mapDispatchToProps))(
  EnhancedListingPage
);

export default ListingPageMarketplace;
